module.exports = ({
    activeSession: 'active_session',
    externalToken: 'external_token',
    bulkQuery: 'bulk-query',
    couponARDiscount: 'coupon-AR-discount',
    hasFirstInvoiceModaBeenSeen: 'has-first-invoice-modal-been-seen',
    invoicesListQuery: 'invoices-list-query',
    quotesListQuery: 'quotes-list-query',
    transactionsListQuery: 'transactions-list-query'
})
